import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { CheckCircleIcon } from 'lucide-react';
const CART_URL = 'https://instanthandbook.com/en/cart/add?id=44085498708019&quantity=1';
const valueItems = [{
  name: 'The Home Healing Handbook\n(300+ remedies, 500+ pages)',
  value: '$97'
}, {
  name: 'Bonus #1 — Your 15-Minute\nNatural First Aid Kit',
  value: '$37'
}, {
  name: 'Bonus #2 — The Remedy Cheat Sheet',
  value: '$47'
}, {
  name: 'Bonus #3 — The Consistency Code',
  value: '$37'
}, {
  name: 'Bonus #4 — The $40 Holistic Pantry',
  value: '$47'
}, {
  name: 'Bonus #5 — Beyond The Basics\nMasterclass',
  value: '$97'
}, {
  name: '14-Day Money Back Guarantee',
  value: 'FREE'
}, {
  name: 'Instant Digital Download',
  value: 'FREE'
}, {
  name: 'Lifetime Access',
  value: 'FREE'
}];
export function FinalCTA() {
  return <section className="py-8 md:py-14 bg-gradient-to-b from-white to-primary/5" data-id="element-86">
      <div className="max-w-3xl mx-auto px-4" data-id="element-87">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-dark mb-4 md:mb-6" data-id="element-88">
          ONE MORE TIME — EVERYTHING YOU GET
        </h2>

        <div className="bg-white rounded-xl border border-primary/10 overflow-hidden mb-4 md:mb-6 shadow-lg" data-id="element-89">
          <div className="divide-y divide-primary/10" data-id="element-90">
            {valueItems.map((item, index) => <div key={index} className="flex items-center gap-3 px-4 py-3 md:px-6 md:py-3.5" data-id="element-91">
                <CheckCircleIcon className="w-5 h-5 text-solution flex-shrink-0" data-id="element-92" />
                <span className="text-dark text-sm md:text-base flex-1 whitespace-pre-line" data-id="element-93">
                  {item.name}
                </span>
                <span className={`font-bold text-sm md:text-base whitespace-nowrap ${item.value === 'FREE' ? 'text-solution' : 'text-dark'}`} data-id="element-94">
                  {item.value}
                </span>
              </div>)}
          </div>

          {/* Total Row */}
          <div className="bg-primary/5 px-4 py-3 md:px-6 md:py-4 border-t-2 border-primary/20" data-id="element-95">
            <div className="flex items-center justify-between" data-id="element-96">
              <span className="font-bold text-dark uppercase tracking-wide text-sm md:text-base" data-id="element-97">
                Total Value
              </span>
              <span className="font-bold text-lg md:text-xl text-muted line-through" data-id="element-98">
                $362
              </span>
            </div>
          </div>
        </div>

        <div className="text-center mb-4 md:mb-6" data-id="element-99">
          <p className="text-muted uppercase tracking-wider text-sm mb-2" data-id="element-100">
            Your Price Today
          </p>
          <PriceDisplay amount={27} size="xl" data-id="element-101" />
        </div>

        <a href="https://instanthandbook.com/en/cart/add?id=44085498708019&quantity=1" className="block w-full bg-primary hover:bg-primary-light text-white font-bold text-xl px-10 py-6 rounded-lg transition-all duration-200 transform hover:scale-[1.02] shadow-xl hover:shadow-2xl text-center" data-id="element-102">
          YES, I WANT INSTANT ACCESS FOR $27 »
        </a>

        <p className="text-center text-muted text-sm mt-4" data-id="element-103">
          One-time payment · Instant download · 14-day guarantee
        </p>

        <p className="text-center text-muted text-xs mt-4 italic" data-id="element-104">
          I reserve the right to close this offer or raise the price without
          notice.
        </p>
      </div>
    </section>;
}